module.exports = __webpack_public_path__ + "static/img/com1_5.255c62b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com1_5.jpg
// module id = 8HbH
// module chunks = 1